module.exports = __webpack_public_path__ + "img/text_llenadora.564ae819.png";